export const MIN_RECHARGE_VALUE_TO_UPGRADE = 1200;
export const RECHARGE_VALUE_TO_UPGRADE = 1500;
export const MIN_RECHARGE_VALUE_TO_SCHEDULE = 3000;
export const MIN_VALUE_BONUS_FIRST_SCHEDULED = 2500;

export const LIMIT_DATE_WILYKIT = 28;
